import 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BASE_API_URL} from '../config/app.config';
import {Area} from '../core/area';
import {Observable} from "rxjs/Observable";

//import { world } from '../core/world';

@Injectable()
export class ParkProvider {

  constructor(private http: HttpClient) {}

  async getAreas(worldId: string, kingdomId: string) {
    const url = BASE_API_URL + 'config/worlds/' + worldId + '/kingdoms/' + kingdomId + '/areas';

    return this.http.get(url).toPromise();
  }

  async searchAreas(partialOnly = false){
    const url = BASE_API_URL + 'config/areas';
    let queryParams = new HttpParams();
    if (partialOnly) {
      queryParams = queryParams.append('representation', 'partial');
    }

    // await new Promise((resolve, reject) => {
    return this.http.get(url, {
      params: queryParams
    }).toPromise();
  }

  getArea(areaId: string): Observable<any> {
    const url = BASE_API_URL + 'config/areas/' + areaId;
    return this.http.get(url);
  }

  checkAreaExists(areaId: string) {
    return this.getArea(areaId)
      .map((res) => {
        return Observable.of(true);
      })
      .catch((err) => {
        if (err.status === 404) {
          // no data found
          return Observable.of(false);
        }
        throw err;
      })
  }

  async getWorlds() {
    let worlds: any = [];

    const url = BASE_API_URL + 'config/worlds';

    return this.http.get(url).toPromise();
  }

  getThings(landId: string, type: string, includeDeactivated: boolean): Promise<any> {
    const url = BASE_API_URL + 'areathings';
    let queryParams = new HttpParams();

    queryParams = queryParams.append('area', landId);

    if (type) {
      queryParams = queryParams.append('type', type);
    }

    if (typeof includeDeactivated !== 'undefined') {
      queryParams = queryParams.append('includeDeactivated', "" + (includeDeactivated === true));
    }

    let promise = new Promise((resolve, reject) => {
      this.http.get(url, {
        params: queryParams
      }).toPromise().then(res => {
        resolve(res);
      })
    });

    return promise;
  }

  addArea(area: Area) {
    const url = BASE_API_URL + 'config/areas';

    let promise = new Promise((resolve, reject) => {
      this.http.post<Area>(url, area, {}).toPromise().then((res) => {
        resolve(res);
      });
    });

    return promise;
  }

  updateArea(areaId: string, area: Area) {
    const url = BASE_API_URL + 'config/areas/' + areaId;

    let promise = new Promise((resolve, reject) => {
      this.http.put<Area>(url, area, {}).toPromise().then((res) => {
        resolve(res);
      })
    });

    return promise;
  }

  getAreaDefaults() {
    const url = BASE_API_URL + 'config/areadefaults';

    let promise = new Promise((resolve, reject) => {
      this.http.get(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/providers/park.provider.ts